import AppDesignPreview from './AppDesignPreview'
import AppDesignSettings from './AppDesignSettings'
import { useAppDispatch } from '../../../hooks/StoreHooks'
import { useConfigEditMode, useLogoUploadNeeded } from '../../../store/selectors/configurationSelector'
import { useEffect, useState } from 'react'
import { companyLogoUploadThunk, editAccentColorThunk, fetchAppDesignThunk } from '../../../store/thunk/configurationThunk'
import { setConfigEditMode } from '../../../store/reducers/configurationReducer'
import { EditIcon, SaveIcon } from '../../../assets/icons/Icons'
import { theme } from '../../../theme'
import { Box } from '@mui/material'
import { ConfigWrapper } from '../Configuration.styles'
import { GeneralButton } from '../../../common/ui/GeneralButton'

const AppDesignContainer = () => {
    const dispatch = useAppDispatch();
    const logoUploadNeeded = useLogoUploadNeeded();
    const [configEditState, setConfigEditState] = useState(useConfigEditMode());

    useEffect(() => {
        dispatch(fetchAppDesignThunk());
    }, []);

    const handleEditMode = async () => {
        if (configEditState) {
            if (logoUploadNeeded) {
                await dispatch(companyLogoUploadThunk())
            }
            await dispatch(editAccentColorThunk())
        }
        dispatch(setConfigEditMode(!configEditState))
        setConfigEditState(!configEditState)
    }

    return (
        <ConfigWrapper>
            <AppDesignSettings />
            <AppDesignPreview />
            <Box style={{ flex: 1 }}></Box>
            <GeneralButton
                appVariant="icon"
                onClick={handleEditMode}
                sx={{ alignSelf: "flex-start" }}
            >
                {configEditState
                    ? <SaveIcon color={theme.palette.companyMain.main} />
                    : <EditIcon color={theme.palette.companyMain.main} />
                }
            </GeneralButton>
        </ConfigWrapper>
    )
}

export default AppDesignContainer